import { Button } from '@/components/ui/button';

interface Props {
  page: number;
  totalPages: number;
  isLoading: boolean;
  onPageChange: (page: number) => void;
}

/**
 * The pager every backoffice list screen shares. Extracted because the three
 * that exist today carried it byte for byte, and the remaining phases add more.
 */
export const AdminPager = ({
  page,
  totalPages,
  isLoading,
  onPageChange,
}: Props) => (
  <div className="flex items-center justify-between">
    <span className="text-sm text-gray-500">
      Página {page + 1} de {Math.max(totalPages, 1)}
    </span>
    <div className="flex gap-2">
      <Button
        variant="outline"
        disabled={page === 0 || isLoading}
        onClick={() => onPageChange(page - 1)}
      >
        Anterior
      </Button>
      <Button
        variant="outline"
        disabled={page + 1 >= totalPages || isLoading}
        onClick={() => onPageChange(page + 1)}
      >
        Siguiente
      </Button>
    </div>
  </div>
);
